export default "__VITE_ASSET__ef90c73e__"